import {
  useQuery,
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseQueryResult
} from 'react-query'
import {
  fetchAutoInvests,
  createAutoInvest,
  deleteAutoInvest,
  AutoInvest
} from 'api/auto_invest'

export function useAutoInvests(): UseQueryResult<AutoInvest[]> {
  return useQuery(['auto-invest'], fetchAutoInvests, { staleTime: 60_000 })
}

export function useMutateCreateAutoInvest(): UseMutationResult<
  AutoInvest,
  unknown,
  {
    productId: number
    vaultId: number
    amount: number
    duration?: string
    investBy: string
  }
> {
  const qc = useQueryClient()
  return useMutation(createAutoInvest, {
    onSuccess: () => {
      qc.invalidateQueries(['auto-invest'])
    }
  })
}

export function useMutateDeleteAutoInvest(): UseMutationResult<
  void,
  unknown,
  number
> {
  const qc = useQueryClient()
  return useMutation(deleteAutoInvest, {
    onSuccess: () => {
      qc.invalidateQueries(['auto-invest'])
    }
  })
}
